<script>
  export let name;
  export let character;
  export let color;
  export let item = {};
  export let handleChange = (e) => {};
</script>

<li>
  <div class="d-flex align-items-center flex-row client-list-item p-1 mb-1 position-relative">
    <div
      class="company-img rounded-circle d-flex align-items-center justify-content-center {color}"
    >
      <label for="checkbox{item.id}">{character}</label>
    </div>
    <div class="w-100 company-title">
      <label
        class="w-100"
        for="checkbox{item.id}">{name}</label
      >
    </div>
    <div class="position-relative">
      <input
        checked={item.checked}
        type="checkbox"
        id="checkbox{item.id}"
        on:change={handleChange}
      />
      <label for="checkbox{item.id}"></label>
    </div>
  </div>
</li>

<style lang="scss">
  .client-list-item {
    border: 1px solid rgba($input-border-color, 0.6);
    border-radius: 20px;
    .company-title {
      padding: 0px 6px;
      word-break: break-word;
      label {
        padding: 6px 0;
      }
    }
    .company-img {
      flex: 0 0 30px;
      max-width: 30px;
      height: 30px;
      border: 1px solid rgba($input-border-color, 0.2);
      color: $white-color;
      background-color: $blue-color;
      margin-right: 6px;

      &.green {
        background: rgba($green-color, 0.1);
        color: $green-color;
      }
      &.red {
        background: rgba($red-color, 0.1);
        color: $red-color;
      }
    }
    .tick-icons {
      flex: 0 0 30px;
      max-width: 30px;
    }
  }

  [type='checkbox']:not(:checked),
  [type='checkbox']:checked {
    position: absolute;
    right: 0;
    opacity: 0.01;
  }
  [type='checkbox']:not(:checked) + label,
  [type='checkbox']:checked + label {
    position: relative;
    padding-left: 2.3em;
    font-size: 1.05em;
    line-height: 1.7;
    cursor: pointer;
  }

  /* checkbox aspect */
  [type='checkbox']:not(:checked) + label:before,
  [type='checkbox']:checked + label:before {
    content: '';
    position: absolute;
    right: 8px;
    top: -13px;
    width: 1.4em;
    height: 1.4em;
    border: 0px;
    background: #fff;
    border-radius: 0.2em;
    border: 1px solid $input-border-color;
    transition: all 0.275s;
  }

  /* checked mark aspect */
  [type='checkbox']:not(:checked) + label:after,
  [type='checkbox']:checked + label:after {
    content: url('/images/check-blue.svg');

    position: absolute;
    top: -14px;
    left: 3px;
    font-size: 1.375em;
    color: $blue-color;
    line-height: 0;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
  }

  /* checked mark aspect changes */
  [type='checkbox']:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0) rotate(45deg);
    transform: scale(0) rotate(45deg);
  }

  [type='checkbox']:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(0.6) rotate(0);
    transform: scale(0.6) rotate(0);
  }

  /* Disabled checkbox */
  [type='checkbox']:disabled:not(:checked) + label:before,
  [type='checkbox']:disabled:checked + label:before {
    box-shadow: none;
    border-color: #bbb;
    background-color: #e9e9e9;
  }

  [type='checkbox']:disabled:checked + label:after {
    color: #777;
  }

  [type='checkbox']:disabled + label {
    color: #aaa;
  }

  /* Accessibility */
</style>
